import React from "react";
import assets from "../assets/assets";

const ServiceCard = () => {
  const {
    demo_it_business_three,
    demo_it_business_four,
    demo_it_business_five,
    demo_it_business_six,
    demo_it_business_seven,
    demo_it_business_eight,
  } = assets();
  return (
    <section class="pt-3 bg-very-light-gray sm-pt-50px position-relative">
      <div class="container">
        <div
          class="row row-cols-1 row-cols-lg-3 row-cols-md-2 justify-content-center mb-8"
          data-anime='{ "el": "childs", "translateY": [30, 0], "translateX": [30, 0], "opacity": [0,1], "duration": 600, "delay": 0, "staggervalue": 300, "easing": "easeOutQuad" }'
        >
          <div class="col mb-30px">
            <div class="services-box-style-03 box-shadow-extra-large last-paragraph-no-margin border-radius-6px overflow-hidden">
              <div class="position-relative">
                <a href="#">
                  <img alt="" src={demo_it_business_three} />
                  <noscript>
                    <img src={demo_it_business_three} alt="" />
                  </noscript>
                </a>
                <a
                  href="#"
                  class="btn btn-very-small btn-rounded btn-dark-gray text-white btn-box-shadow ps-15px pe-15px pt-5px pb-5px lh-16 position-absolute right-30px top-30px text-uppercase"
                >
                  analytics
                </a>
              </div>
              <div class="bg-white">
                <div class="ps-65px pe-65px lg-ps-40px lg-pe-40px pt-30px pb-30px text-center progress-bar-style-01">
                  <a
                    href="#"
                    class="d-inline-block fs-18 fw-700 text-dark-gray mb-5px"
                  >
                    Data and analytics
                  </a>
                  <p>Lorem ipsum simply dummy text of amet consectetur.</p>
                </div>
                <div class="d-flex justify-content-center border-top border-color-extra-medium-gray pt-20px pb-20px ps-50px pe-50px position-relative text-center">
                  <a
                    href="#"
                    class="btn btn-link btn-hover-animation-switch btn-medium fw-700 text-dark-gray text-uppercase"
                  >
                    <span>
                      <span class="btn-text">Explore services</span>
                      <span class="btn-icon">
                        <i class="fa-solid fa-arrow-right"></i>
                      </span>
                      <span class="btn-icon">
                        <i class="fa-solid fa-arrow-right"></i>
                      </span>
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="col mb-30px">
            <div class="services-box-style-03 box-shadow-extra-large last-paragraph-no-margin border-radius-6px overflow-hidden">
              <div class="position-relative">
                <a href="#">
                  <img alt="" src={demo_it_business_four} />
                  <noscript>
                    <img src={demo_it_business_four} alt="" />
                  </noscript>
                </a>
                <a
                  href="#"
                  class="btn btn-very-small btn-rounded btn-dark-gray text-white btn-box-shadow ps-15px pe-15px pt-5px pb-5px lh-16 position-absolute right-30px top-30px text-uppercase"
                >
                  Finance
                </a>
              </div>
              <div class="bg-white">
                <div class="ps-65px pe-65px lg-ps-40px lg-pe-40px pt-30px pb-30px text-center progress-bar-style-01">
                  <a
                    href="#"
                    class="d-inline-block fs-18 fw-700 text-dark-gray mb-5px"
                  >
                    Finance consulting
                  </a>
                  <p>Lorem ipsum simply dummy text of amet consectetur.</p>
                </div>
                <div class="d-flex justify-content-center border-top border-color-extra-medium-gray pt-20px pb-20px ps-50px pe-50px position-relative text-center">
                  <a
                    href="#"
                    class="btn btn-link btn-hover-animation-switch btn-medium fw-700 text-dark-gray text-uppercase"
                  >
                    <span>
                      <span class="btn-text">Explore services</span>
                      <span class="btn-icon">
                        <i class="fa-solid fa-arrow-right"></i>
                      </span>
                      <span class="btn-icon">
                        <i class="fa-solid fa-arrow-right"></i>
                      </span>
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="col mb-30px">
            <div class="services-box-style-03 box-shadow-extra-large last-paragraph-no-margin border-radius-6px overflow-hidden">
              <div class="position-relative">
                <a href="#">
                  <img alt="" src={demo_it_business_five} />
                  <noscript>
                    <img src={demo_it_business_five} alt="" />
                  </noscript>
                </a>
                <a
                  href="#"
                  class="btn btn-very-small btn-rounded btn-dark-gray text-white btn-box-shadow ps-15px pe-15px pt-5px pb-5px lh-16 position-absolute right-30px top-30px text-uppercase"
                >
                  analytics
                </a>
              </div>
              <div class="bg-white">
                <div class="ps-65px pe-65px lg-ps-40px lg-pe-40px pt-30px pb-30px text-center progress-bar-style-01">
                  <a
                    href="#"
                    class="d-inline-block fs-18 fw-700 text-dark-gray mb-5px"
                  >
                    Technology innovation
                  </a>
                  <p>Lorem ipsum simply dummy text of amet consectetur.</p>
                </div>
                <div class="d-flex justify-content-center border-top border-color-extra-medium-gray pt-20px pb-20px ps-50px pe-50px position-relative text-center">
                  <a
                    href="#"
                    class="btn btn-link btn-hover-animation-switch btn-medium fw-700 text-dark-gray text-uppercase"
                  >
                    <span>
                      <span class="btn-text">Explore services</span>
                      <span class="btn-icon">
                        <i class="fa-solid fa-arrow-right"></i>
                      </span>
                      <span class="btn-icon">
                        <i class="fa-solid fa-arrow-right"></i>
                      </span>
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="col md-mb-30px">
            <div class="services-box-style-03 box-shadow-extra-large last-paragraph-no-margin border-radius-6px overflow-hidden">
              <div class="position-relative">
                <a href="#">
                  <img alt="" src={demo_it_business_six} />
                  <noscript>
                    <img src={demo_it_business_six} alt="" />
                  </noscript>
                </a>
                <a
                  href="#"
                  class="btn btn-very-small btn-rounded btn-dark-gray text-white btn-box-shadow ps-15px pe-15px pt-5px pb-5px lh-16 position-absolute right-30px top-30px text-uppercase"
                >
                  Digital
                </a>
              </div>
              <div class="bg-white">
                <div class="ps-65px pe-65px lg-ps-40px lg-pe-40px pt-30px pb-30px text-center progress-bar-style-01">
                  <a
                    href="#"
                    class="d-inline-block fs-18 fw-700 text-dark-gray mb-5px"
                  >
                    Digital commerce
                  </a>
                  <p>Lorem ipsum simply dummy text of amet consectetur.</p>
                </div>
                <div class="d-flex justify-content-center border-top border-color-extra-medium-gray pt-20px pb-20px ps-50px pe-50px position-relative text-center">
                  <a
                    href="/services"
                    class="btn btn-link btn-hover-animation-switch btn-medium fw-700 text-dark-gray text-uppercase"
                  >
                    <span>
                      <span class="btn-text">Explore services</span>
                      <span class="btn-icon">
                        <i class="fa-solid fa-arrow-right"></i>
                      </span>
                      <span class="btn-icon">
                        <i class="fa-solid fa-arrow-right"></i>
                      </span>
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="col sm-mb-30px">
            <div class="services-box-style-03 box-shadow-extra-large last-paragraph-no-margin border-radius-4px overflow-hidden">
              <div class="position-relative">
                <a href="#">
                  <img
                    alt=""
                    src={demo_it_business_three}
                  />
                  <noscript>
                    <img src={demo_it_business_three} alt="" />
                  </noscript>
                </a>
                <a
                  href="#"
                  class="btn btn-very-small btn-rounded btn-dark-gray text-white btn-box-shadow ps-15px pe-15px pt-5px pb-5px lh-16 position-absolute right-30px top-30px text-uppercase"
                >
                  Digital
                </a>
              </div>
              <div class="bg-white">
                <div class="ps-65px pe-65px lg-ps-40px lg-pe-40px pt-30px pb-30px text-center progress-bar-style-01">
                  <a
                    href="#"
                    class="d-inline-block fs-18 fw-700 text-dark-gray mb-5px"
                  >
                    Artificial intelligence
                  </a>
                  <p>Lorem ipsum simply dummy text of amet consectetur.</p>
                </div>
                <div class="d-flex justify-content-center border-top border-color-extra-medium-gray pt-20px pb-20px ps-50px pe-50px position-relative text-center">
                  <a
                    href="#"
                    class="btn btn-link btn-hover-animation-switch btn-medium fw-700 text-dark-gray text-uppercase"
                  >
                    <span>
                      <span class="btn-text">Explore services</span>
                      <span class="btn-icon">
                        <i class="fa-solid fa-arrow-right"></i>
                      </span>
                      <span class="btn-icon">
                        <i class="fa-solid fa-arrow-right"></i>
                      </span>
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="col">
            <div class="services-box-style-03 box-shadow-extra-large last-paragraph-no-margin border-radius-4px overflow-hidden">
              <div class="position-relative">
                <a href="#">
                  <img
                    alt=""
                    src={demo_it_business_four}
                  />
                  <noscript>
                    <img src={demo_it_business_four} alt="" />
                  </noscript>
                </a>
                <a
                  href="#"
                  class="btn btn-very-small btn-rounded btn-dark-gray text-white btn-box-shadow ps-15px pe-15px pt-5px pb-5px lh-16 position-absolute right-30px top-30px text-uppercase"
                >
                  Digital
                </a>
              </div>
              <div class="bg-white">
                <div class="ps-65px pe-65px lg-ps-40px lg-pe-40px pt-30px pb-30px text-center progress-bar-style-01">
                  <a
                    href="#"
                    class="d-inline-block fs-18 fw-700 text-dark-gray mb-5px"
                  >
                    Cloud computing
                  </a>
                  <p>Lorem ipsum simply dummy text of amet consectetur.</p>
                </div>
                <div class="d-flex justify-content-center border-top border-color-extra-medium-gray pt-20px pb-20px ps-50px pe-50px position-relative text-center">
                  <a
                    href="#"
                    class="btn btn-link btn-hover-animation-switch btn-medium fw-700 text-dark-gray text-uppercase"
                  >
                    <span>
                      <span class="btn-text">Explore services</span>
                      <span class="btn-icon">
                        <i class="fa-solid fa-arrow-right"></i>
                      </span>
                      <span class="btn-icon">
                        <i class="fa-solid fa-arrow-right"></i>
                      </span>
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="shape-image-animation p-0 w-100 bottom-minus-40px xl-bottom-0px d-none d-md-block">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          widht="3000"
          height="400"
          viewBox="0 180 2500 200"
          fill="#ffffff"
        >
          <path
            class="st1"
            d="M 0 250 C 1200 400 1200 50 3000 250 L 3000 550 L 0 550 L 0 250"
          >
            <animate
              attributeName="d"
              dur="5s"
              values="M 0 250 C 1200 400 1200 50 3000 250 L 3000 550 L 0 550 L 0 250;
                            M 0 250 C 400 50 400 400 3000 250 L 3000 550 L 0 550 L 0 250;
                            M 0 250 C 1200 400 1200 50 3000 250 L 3000 550 L 0 550 L 0 250"
              repeatCount="indefinite"
            />
          </path>
        </svg>
      </div>
    </section>
  );
};

export default ServiceCard;
